import { jsx, jsxs } from "react/jsx-runtime";
import AntDropdown from "antd/es/dropdown";
import classnames from "../../utils/classnames.js";
import './Dropdown.css';/* empty css              */
const Dropdown = ({
  className,
  openClassName,
  overlayClassName,
  items,
  onSelect,
  title,
  selected,
  ...props
}) => {
  const { label, icon } = selected;
  return /* @__PURE__ */ jsx(
    AntDropdown,
    {
      className: classnames("perxis-auto-dropdown-trigger", className),
      overlayClassName: classnames("perxis-auto-dropdown", overlayClassName),
      openClassName: classnames("perxis-auto-dropdown--open", openClassName),
      menu: { items, onClick: (e) => onSelect == null ? void 0 : onSelect(e.key) },
      trigger: ["click"],
      ...props,
      children: /* @__PURE__ */ jsxs("a", { children: [
        /* @__PURE__ */ jsxs("span", { className: classnames("perxis-auto-dropdown-trigger__title"), children: [
          title,
          " "
        ] }),
        /* @__PURE__ */ jsxs("span", { className: classnames("perxis-auto-dropdown-trigger__value"), children: [
          !!label && /* @__PURE__ */ jsx("span", { className: classnames("perxis-auto-dropdown-trigger__label"), children: label }),
          !!icon && /* @__PURE__ */ jsx("span", { className: classnames("perxis-auto-dropdown-trigger__icon"), children: icon })
        ] })
      ] })
    }
  );
};
export {
  Dropdown as default
};
//# sourceMappingURL=Dropdown.js.map
